import { PrismicState } from '../types/PrismicState'

export const state: PrismicState = {
  pages: {},
  totalResultsSize: {},
  blocks: {},
  alternateLanguages: {}
}
